import { Configuration, PopupRequest } from '@azure/msal-browser';

// Azure Entra ID configuration for OWT organization
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env?.VITE_AZURE_AD_CLIENT_ID || 'your-client-id', // Your app registration client ID
    authority: `https://login.microsoftonline.com/${import.meta.env?.VITE_AZURE_AD_TENANT_ID || 'your-tenant-id'}`, // Your OWT tenant ID
    redirectUri: import.meta.env?.VITE_AZURE_AD_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true, // Navigate back to the original request location after login
  },
  cache: {
    cacheLocation: 'localStorage', // Store tokens in localStorage for persistence across browser sessions
    storeAuthStateInCookie: true, // Set to true for better incognito mode support
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (level: any, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case 0: console.error(message); break; // Error
          case 1: console.warn(message); break;  // Warning
          case 2: console.info(message); break;  // Info
          case 3: console.log(message); break;   // Verbose
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

// Login request configuration
export const loginRequest: PopupRequest = {
  scopes: [
    'openid',
    'profile', 
    'email',
    'User.Read', // Microsoft Graph permission to read user profile
  ],
  prompt: 'select_account', // Force account selection on login
};

// Silent token request for API calls
export const silentRequest = {
  scopes: [
    'openid',
    'profile',
    'email', 
    'User.Read',
  ],
  forceRefresh: false, // Set to true to skip cache and go to server
};

// Microsoft Graph API configuration
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphMailEndpoint: 'https://graph.microsoft.com/v1.0/me/messages',
  graphUsersEndpoint: 'https://graph.microsoft.com/v1.0/users',
};

// Sentinel API configuration
export const apiConfig = {
  // Custom API scope so the access token audience matches the backend's AZURE_AD_CLIENT_ID
  scopes: [`api://${import.meta.env?.VITE_AZURE_AD_CLIENT_ID || 'your-client-id'}/access_as_user`],
  uri: import.meta.env?.VITE_API_BASE_URL || 'http://localhost:8080/api/v1',
};

// Protected resources endpoints
export const protectedResources = {
  // Microsoft Graph
  graphMe: {
    endpoint: 'https://graph.microsoft.com/v1.0/me',
    scopes: ['User.Read'],
  },
  // Sentinel API
  sentinelApi: {
    endpoint: apiConfig.uri,
    scopes: apiConfig.scopes,
  },
};

// Login hint for your organization (optional - helps with user experience)
export const organizationHint = import.meta.env?.VITE_ORGANIZATION_HINT || 'owt.ch';